import Counter from './ContextUpdate';

export default Counter;